import { render, staticRenderFns } from "./RamoFianzasComponent.vue?vue&type=template&id=3456a6c5"
import script from "./RamoFianzasComponent.vue?vue&type=script&lang=js"
export * from "./RamoFianzasComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports